import { Link } from "react-router-dom";

function SideBookingCta({ href = "/booking" }) {
  const isRouteCta =
    typeof href === "string" &&
    !href.startsWith("#") &&
    !href.startsWith("/#") &&
    !href.startsWith("mailto:");

  const content = (
    <span className="side-booking-cta__inner">
      <span className="side-booking-cta__avatar">
        <img
          src="/book-meeting-agent.jpg"
          alt="Book Meeting"
          className="side-booking-cta__avatar-image"
          draggable="false"
          onContextMenu={(event) => event.preventDefault()}
        />
      </span>
      <span className="side-booking-cta__label">
        Book Meeting
      </span>
    </span>
  );

  const desktopClassName = "side-booking-cta fixed right-0 top-1/2 z-40 hidden -translate-y-1/2 lg:block";
  const mobileClassName = "fixed bottom-5 right-5 z-40 inline-flex items-center gap-3 rounded-full border border-amber-300/80 bg-[#ffcc1f] px-4 py-3 text-sm font-semibold text-slate-950 shadow-[0_18px_40px_rgba(15,23,42,0.22)] transition hover:bg-[#ffd84a] lg:hidden";

  return (
    <>
      {isRouteCta ? (
        <Link to={href} className={desktopClassName} aria-label="Book Meeting" onContextMenu={(event) => event.preventDefault()}>
          {content}
        </Link>
      ) : (
        <a href={href} className={desktopClassName} aria-label="Book Meeting" onContextMenu={(event) => event.preventDefault()}>
          {content}
        </a>
      )}

      {isRouteCta ? (
        <Link to={href} className={mobileClassName} onContextMenu={(event) => event.preventDefault()}>
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-950 text-sm font-semibold text-white shadow-[0_8px_18px_rgba(15,23,42,0.2)]">
            N
          </span>
          Book Meeting
        </Link>
      ) : (
        <a href={href} className={mobileClassName} onContextMenu={(event) => event.preventDefault()}>
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-950 text-sm font-semibold text-white shadow-[0_8px_18px_rgba(15,23,42,0.2)]">
            N
          </span>
          Book Meeting
        </a>
      )}
    </>
  );
}

export default SideBookingCta;
